define((require) => {
    "use strict";

    const Enum = require("shared/util/Enum");

    /**
     * Enumeration representing the state of a <i>publishable</i> entity, e.g. an experience, where the <tt>value</tt> is equal
     * to <tt>experienceModel.get("state")</tt>.
     *
     * @see ExperienceModel
     * @see GroupModel
     *
     * @class PublishableState
     * @author Kim
     */
    const PublishableState = Enum.create(
        "PublishableState", "value",
        {
            DELETED: {
                value: "Deleted",
                displayName: "Deleted"
            },

            INACTIVE: {
                value: "Inactive",
                displayName: "Inactive"
            },

            NOT_PUSHED: {
                value: "NotPushed",
                displayName: "Not pushed"
            },

            PUSHED: {
                value: "Pushed",
                displayName: "Pushed"
            },

            SCHEDULED: {
                value: "Scheduled",
                displayName: "Scheduled"
            },

            PUBLISHED: {
                value: "Published",
                displayName: "Published"
            }
        },
        {
            /**
             * Compares the specified states for order, and returns the greatest.<p>
             *
             * If they're equal, the state is returned.
             *
             * @param  {PublishableState|String|Number} a The first state to compare.
             * @param  {PublishableState|String|Number} b The second state to compare.
             *
             * @return {PublishableState} The greatest state, as a <tt>PublishableState</tt> enum.
             */
            greatest(a, b) {
                const enumA = PublishableState.getEnum(a);
                const enumB = PublishableState.getEnum(b);

                return enumA._ordinal > enumB._ordinal ? enumA : enumB;
            },

            atLeast(a, b) {
                const enumA = PublishableState.getEnum(a);
                const enumB = PublishableState.getEnum(b);

                return enumA._ordinal >= enumB._ordinal;
            },

            /**
             * Returns the matching enumeration from the specified value. If no enumeration matched, <tt>NOT_PUSHED</tt> is returned.<p>
             *
             * <pre>
             * PublishableState.getEnum(INACTIVE);          // INACTIVE
             * PublishableState.getEnum(INACTIVE.value);    // INACTIVE
             * PublishableState.getEnum(INACTIVE._ordinal); // INACTIVE
             * PublishableState.getEnum(0);                 // INACTIVE
             * PublishableState.getEnum("Published");       // PUBLISHED
             * PublishableState.getEnum(42);                // NOT_PUSHED
             * PublishableState.getEnum("gro");             // NOT_PUSHED
             * </pre>
             *
             * @param  {PublishableState|String|Number} value Either the raw string value, e.g. <tt>"Inactive"</tt> or <tt>INACTIVE.value</tt>, the
             *                                                numeric ordinal value, e.g. <tt>0</tt> or for convenience, a
             *                                                valid <tt>PublishableState</tt> enum.
             *
             * @return {PublishableState}                     The matching enumeration or <tt>NOT_PUSHED</tt> if no enumeration matched.
             */
            getEnum(value) {
                return PublishableState.lookup(value, PublishableState.NOT_PUSHED);
            }
        }
    );

    return PublishableState;
});



// WEBPACK FOOTER //
// ./src/editor/util/PublishableState.js